/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OdbCriteriaNote
 */
export interface OdbCriteriaNote {
    /**
     * 
     * @type {string}
     * @memberof OdbCriteriaNote
     */
    seq?: string;
    /**
     * 
     * @type {string}
     * @memberof OdbCriteriaNote
     */
    reason_for_use_id?: string;
    /**
     * 
     * @type {string}
     * @memberof OdbCriteriaNote
     */
    note_type?: string;
    /**
     * 
     * @type {string}
     * @memberof OdbCriteriaNote
     */
    text?: string;
}

/**
 * Check if a given object implements the OdbCriteriaNote interface.
 */
export function instanceOfOdbCriteriaNote(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OdbCriteriaNoteFromJSON(json: any): OdbCriteriaNote {
    return OdbCriteriaNoteFromJSONTyped(json, false);
}

export function OdbCriteriaNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): OdbCriteriaNote {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'seq': !exists(json, 'seq') ? undefined : json['seq'],
        'reason_for_use_id': !exists(json, 'reason_for_use_id') ? undefined : json['reason_for_use_id'],
        'note_type': !exists(json, 'note_type') ? undefined : json['note_type'],
        'text': !exists(json, 'text') ? undefined : json['text'],
    };
}

export function OdbCriteriaNoteToJSON(value?: OdbCriteriaNote | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'seq': value.seq,
        'reason_for_use_id': value.reason_for_use_id,
        'note_type': value.note_type,
        'text': value.text,
    };
}

